export const getIsOnSearchMode = state => {
  return state.isOnSearchMode;
};